@if (isShow && usersWithoutAccess && usersWithoutAccess.length) {
    <div class="mention-notification">
        <app-highlight-mention [mentionedUsers]="usersWithoutAccess" [message]="text"></app-highlight-mention>

        <div class="d-flex justify-content-end mt-2">
            <button class="btn me-3" (click)="doNothing()" translate>Do nothing</button>
            <button class="btn" (click)="grantAccess()" translate>Grant access</button>
        </div>
    </div>
}
